var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-btn"},[_c('button',{staticClass:"btn",attrs:{"type":_vm.type,"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[_c('span',[_vm._v(_vm._s(_vm.placeholder))])])])}
var staticRenderFns = []

export { render, staticRenderFns }